<template>
  <div :class="{ 'pt-48 md:pt-80': shouldShowHeader }">
    <GlobalNav v-if="shouldShowHeader && account?.isParent()" />
    <SitterNav v-else-if="shouldShowHeader && account?.isSitter()" />
    <router-view />
  </div>
</template>

<script lang="ts">
import { readMetaBoolean } from '@/lib/page';
import GlobalNav from '@/components/nav/GlobalNav.vue';
import SitterNav from '@/components/nav/SitterNav.vue';

export default {
  name: 'Root',
  components: {
    GlobalNav,
    SitterNav,
  },
  computed: {
    account() {
      return this.$store.getters['account/getAccount'];
    },
    shouldShowHeader() {
      return !readMetaBoolean('native_mobile_app');
    },
  },
};
</script>
